/**
 * Trigger the green sweep animation on a DataGrid row element.
 * @param {HTMLElement|null} rowEl — the .MuiDataGrid-row element
 * @param {() => void} [onComplete] — when sweep-in has finished and slide-out begins (overlay gets `.exiting`), not after overlay is gone
 */
export function triggerSweep(rowEl, onComplete) {
  if (!rowEl) return;

  const overlay = document.createElement('div');
  overlay.className = 'sweep-overlay';
  rowEl.appendChild(overlay);

  setTimeout(() => {
    rowEl.style.background = 'var(--green-final)';
    rowEl.classList.add('town-accept-row-final');
    overlay.classList.add('exiting');
    onComplete?.();
    setTimeout(() => {
      overlay.remove();
    }, 420);
  }, 450);
}

/**
 * Find a MUI DataGrid row element by its data-id attribute.
 * @param {HTMLElement|null|undefined} gridRoot — wrapper containing the DataGrid
 * @param {string|number} rowId
 * @returns {HTMLElement|null}
 */
export function findRowEl(gridRoot, rowId) {
  if (!gridRoot || rowId == null) return null;
  const id = String(rowId);
  const root = gridRoot.querySelector('.MuiDataGrid-root') || gridRoot;
  const esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id;
  return (
    root.querySelector(`.MuiDataGrid-row[data-id="${esc}"]`) ||
    Array.from(root.querySelectorAll('.MuiDataGrid-row')).find((el) => el.getAttribute('data-id') === id) ||
    null
  );
}

/**
 * Run the sweep by row ID.
 * @param {HTMLElement|null|undefined} gridRoot
 * @param {string|number} rowId
 * @param {() => void} [onComplete] — when sweep-in is done and slide-out starts (same moment row bg is set)
 */
export function runRowCompletionAnimation(gridRoot, rowId, onComplete) {
  const rowEl = findRowEl(gridRoot, rowId);
  if (!rowEl) return;
  triggerSweep(rowEl, onComplete);
}

/**
 * Revert row visuals after a failed settlement.
 * @param {HTMLElement|null|undefined} gridRoot
 * @param {string|number} rowId
 */
export function revertRowCompletionStyling(gridRoot, rowId) {
  const rowEl = findRowEl(gridRoot, rowId);
  if (!rowEl) return;
  rowEl.querySelectorAll('.sweep-overlay').forEach((el) => el.remove());
  rowEl.style.background = '';
  rowEl.classList.remove('town-accept-row-final');
}
